import { render } from "./expertBookingOverviewTable.vue?vue&type=template&id=c4120e2a&scoped=true&ts=true"
import script from "./expertBookingOverviewTable.vue?vue&type=script&lang=ts"
export * from "./expertBookingOverviewTable.vue?vue&type=script&lang=ts"

import "./expertBookingOverviewTable.vue?vue&type=style&index=0&id=c4120e2a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4120e2a"]])

export default __exports__